import React from 'react';
import { Stack, Typography } from '@mui/material';

/**
 * The heading over a section further down a page (a survey's transects, the
 * dashboard's recent surveys), with an optional small button on the right.
 * Leave SECTION_GAP above it (on the panel before it); it adds 12px below.
 */
const SectionHeader = ({ title, action }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1.5, minHeight: 32 }}>
    <Typography variant="h3" component="h2">{title}</Typography>
    {action}
  </Stack>
);

export default SectionHeader;
